import * as React from 'react';
import { Bar } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useMediaQuery, useTheme } from '@mui/material';

import { IChartData } from 'models';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartVerticalProps {
  data: IChartData;
}

export const BarChartVertical = (props: BarChartVerticalProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { data } = props;
  const options = {
    responsive: true,
    aspectRatio: isMobile ? 2 : 1.2,
    barPercentage: 0.6,
    borderRadius: 4,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: true,
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: theme.palette.primary.main,
          font: {
            weight: 'bold',
            size: 14,
          },
        },
      },
      y: {
        display: false,
        stacked: true,
      },
    },
  };

  return <Bar options={options} data={data} />;
};
